import { ConnectorName } from '@/wallet/WalletStore.types';

export const NAMES_MAP: Record<ConnectorName, string | undefined> = {
    metamask: 'Metamask',
    logiumWallet: 'Logium',
};
